import React from "react";

export const Footer = () => {
  return (
    <div id="footer">
      <div className="container text-center">
        <p><em>Copyright &copy; 2024 Beauty Salon. Tous droits réservés.</em></p>
      </div>
    </div>
  );
};
